var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGreenLoanClean128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5386 53.4163V106.223C26.5386 108.189 28.0701 109.782 29.9594 109.782H102.224C104.113 109.782 105.645 108.189 105.645 106.223V53.4163C105.645 52.3801 105.211 51.3952 104.456 50.7191L68.3236 18.3531C67.0406 17.2039 65.1427 17.2039 63.8598 18.3531L27.7275 50.7191C26.9727 51.3952 26.5386 52.3801 26.5386 53.4163Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9282 56.5615V61.3035",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.186 56.5615V61.3035",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2407 91.847H87.861C88.9656 91.847 89.861 90.9516 89.861 89.847V71.3301",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.67 61.5038C97.67 61.3933 97.5805 61.3037 97.47 61.3037H83.6438C83.5333 61.3037 83.4438 61.3933 83.4438 61.5037V65.2555C83.4438 68.311 86.6284 70.7879 90.5569 70.7879C94.4854 70.7879 97.67 68.311 97.67 65.2555V61.5038Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5483 98.6748H34.258V104.917C34.258 107.598 32.0844 109.772 29.4031 109.772C26.7219 109.772 24.5483 107.598 24.5483 104.917V98.6748Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8384 98.6748H67.5481V104.917C67.5481 107.598 65.3745 109.772 62.6933 109.772C60.012 109.772 57.8384 107.598 57.8384 104.917V98.6748Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4509 72.4728L26 80.6425H66.9193L64.4684 72.4728C63.4532 69.0889 60.3386 66.7715 56.8058 66.7715H36.1135C32.5807 66.7715 29.4661 69.0889 28.4509 72.4728Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0967 100.755H19V88.9656C19 81.7527 25.9355 79.4871 29.4032 79.2559H62.6935C71.016 79.2559 73.0967 85.729 73.0967 88.9656V100.755Z",
    fill: "#1A7D1A",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6453 90.3517C35.6453 92.6501 33.7821 94.513 31.4844 94.513C29.186 94.513 27.3228 92.6501 27.3228 90.3517C27.3228 88.0534 29.186 86.1904 31.4844 86.1904C33.7821 86.1904 35.6453 88.0534 35.6453 90.3517Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7743 90.3517C64.7743 92.6501 62.9111 94.513 60.6134 94.513C58.315 94.513 56.4517 92.6501 56.4517 90.3517C56.4517 88.0534 58.315 86.1904 60.6134 86.1904C62.9111 86.1904 64.7743 88.0534 64.7743 90.3517Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1094 16.7842L79.5702 23.4428",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.436 26.8379L94.0984 36.3544",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4248 40.2695L105.885 46.9281",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGreenLoanClean128);
export default __webpack_public_path__ + "static/media/pictogramBeaconGreenLoanClean128.0349a081df15594fda4e20f0f0f7a11b.svg";
export { ForwardRef as ReactComponent };